import { motion } from "framer-motion";
import { NavLink } from "react-router-dom";

interface TabItem {
  label: string;
  to: string;
  isActive: boolean;
}

interface SubNavTabsProps {
  tabs: TabItem[];
}

const SubNavTabs = ({ tabs }: SubNavTabsProps) => {
  return (
    <div className="sub-nav-tabs">
      {tabs.map((tab) => (
        <NavLink
          key={tab.label}
          to={tab.to}
          className="sub-nav-tab"
          style={{ textDecoration: "none" }}
        >
          {tab.isActive && (
            <motion.div
              className="sub-nav-pill"
              layoutId="sub-nav-pill"
              transition={{ type: "spring", stiffness: 380, damping: 32 }}
            />
          )}
          <span className={`sub-nav-label${tab.isActive ? " active" : ""}`}>
            {tab.label}
          </span>
        </NavLink>
      ))}
    </div>
  );
};

export default SubNavTabs;
